import React, { useState } from "react";
import { Flex, Button, useColorModeValue } from "@chakra-ui/react";

const CopyButton = ({ value }) => {
  const [isCopied, setIsCopied] = useState(false);

  const textColor = useColorModeValue("black", "white");

  const handleCopyClick = () => {
    navigator.clipboard.writeText(value);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <Flex justify="center" marginTop="1rem" marginX="0.5rem">
      <Button onClick={handleCopyClick} color={textColor}>
        {isCopied ? "Copied" : "Copy"}
      </Button>
    </Flex>
  );
};

export default CopyButton;
